import React, { useEffect, useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { db } from "../firebase";
import { Helmet } from "react-helmet";
import {
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { Link } from "react-router-dom";
import { FiHeart } from "react-icons/fi";

export default function Favoris() {
  const { user } = useAuth();
  const [favoris, setFavoris] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFavoris = async () => {
      if (!user) return;

      try {
        const favQuery = query(
          collection(db, "favoris"),
          where("userId", "==", user.uid)
        );
        const favSnapshot = await getDocs(favQuery);

        const vehiclePromises = favSnapshot.docs.map(async (favDoc) => {
          const slug = favDoc.data().vehicleId; // ← c'est en fait le slug ici
          const vehiculeQuery = query(
            collection(db, "vehicules_auto"),
            where("slug", "==", slug)
          );
          const snap = await getDocs(vehiculeQuery);

          if (!snap.empty) {
            const docSnap = snap.docs[0];
            return {
              id: docSnap.id,
              ...docSnap.data(),
              favoriDocId: favDoc.id, // ← pour suppression
            };
          }
          return null;
        });

        const vehicles = await Promise.all(vehiclePromises);
        setFavoris(vehicles.filter(Boolean));
      } catch (error) {
        console.error("Erreur lors du chargement des favoris :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFavoris();
  }, [user]);

  const handleRemoveFavori = async (favoriDocId) => {
    try {
      await deleteDoc(doc(db, "favoris", favoriDocId));
      setFavoris((prev) => prev.filter((v) => v.favoriDocId !== favoriDocId));
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
    }
  };

  if (!user) {
    return <div className="container py-5 text-center">Veuillez vous connecter pour voir vos favoris.</div>;
  }

  if (loading) return <div className="container py-5 text-center">Chargement...</div>;

  return (
    <div className="container py-5">
      <Helmet>
                <title>Mes véhicules</title>
                <meta
                    name="description"
                    content="THE BRIDGE SARL est spécialisée dans la commande personnalisée, la vente et l’importation de véhicules neufs et d’occasions au Togo. Votre partenaire auto de confiance en Afrique."
                />
                <meta
                    name="keywords"
                    content="The bridge, commande voiture Togo, importation véhicule Afrique, vente voiture occasions, The Bridge SARL, voiture neuve Togo, service automobile Lomé, voiture personnalisée Togo"
                />
                <meta name="author" content="The Bridge of World" />
                <meta property="og:title" content="THE BRIDGE SARL | Vente, Commande & Importation de Voitures" />
                <meta
                    property="og:description"
                    content="Découvrez THE BRIDGE SARL : importation, vente et commandes personnalisées de véhicules adaptés à vos besoins. Qualité, service et fiabilité au Togo."
                />
                <meta property="og:url" content="https://thebridgeofworld.com/a-propos" />
                <meta property="og:type" content="website" />
            </Helmet>
      <h3 className="mb-4">Mes véhicules favoris</h3>
      {favoris.length === 0 ? (
        <p>Vous n'avez encore aucun véhicule en favori.</p>
      ) : (
        <div className="row">
          {favoris.map((vehicle) => (
            <div key={vehicle.id} className="col-md-4 mb-4">
              <div className="card h-100 shadow-sm">
                <img
                  src={vehicle.imageUrls?.[0]}
                  className="card-img-top"
                  alt={`${vehicle.marque} ${vehicle.modele}`}
                  style={{ height: 200, objectFit: "cover" }}
                />
                <div className="card-body d-flex flex-column justify-content-between">
                  <div>
                    <h5 className="card-title">
                      {vehicle.marque} {vehicle.modele}
                    </h5>
                    <p className="card-text">
                      {vehicle.annee} • {parseInt(vehicle.prix).toLocaleString("fr-FR")} FCFA
                    </p>
                  </div>

                  <div className="d-flex justify-content-between mt-3">
                    <Link to={`/vehicules/${vehicle.slug}`} className="btn btn-sm btn-primary">
                      Voir
                    </Link>
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleRemoveFavori(vehicle.favoriDocId)}
                      title="Retirer des favoris"
                    >
                      <FiHeart /> Retirer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
